export const locationDetailsCache = new Map<string, any>();
export const locationDetailsInFlight = new Map<string, Promise<any>>();
